module.exports = require('./lib')


/** WEBPACK FOOTER **
 ** ../biro/index.js
 **/